'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const NonReentrantCommand=require('../../../../dist-es6/client/angularCommon/nonReentrantCommand');let

CommandStatusDirective=class CommandStatusDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['command'];
}

get textBindings(){
return['inProgressText','completionText'];
}

get templateUrl(){
return'/templates/directives/commandStatusDirective/commandStatusTemplate';
}

get controller(){
return CommandStatusDirectiveController;
}};let


CommandStatusDirectiveController=class CommandStatusDirectiveController{
static get $inject(){
return['$scope','$timeout','$element'];
}

constructor($scope,$timeout,$element){
if(!_.exists(this.command)||!(this.command instanceof NonReentrantCommand)){
throw new Error('CommandStatusDirective must get NonReentrantCommand as controller.command');
}

this.inProgressText=!_.exists(this.inProgressText)||this.inProgressText===''?'Saving...':this.inProgressText;
this.completionText=!_.exists(this.completionText)||this.completionText===''?'Saved':this.completionText;

this._showCompletionText=!1;
this._$timeout=$timeout;

$scope.$watch('controller.command',()=>{
if(_.exists(this._observer)){
this._observer.dispose();
}

this._observer=this.command.onInProgressChanged.subscribe(this._onInProgressChangedHandler.bind(this));
});

$scope.$on('$destroy',()=>{
this._observer.dispose();
});
}

_onInProgressChangedHandler(isInProgress){
if(isInProgress){
this._hideCompletionText();
return;
}

this._showCompletionTextForSeconds(2);
}

_hideCompletionText(){
this._$timeout(()=>{
this._showCompletionText=!1;
if(this._outstandingTextUpdate){
this._$timeout.cancel(this._outstandingTextUpdate);
this._outstandingTextUpdate=null;
}
});
}

_showCompletionTextForSeconds(timeInSeconds){
this._$timeout(()=>{
this._showCompletionText=!0;
this._outstandingTextUpdate=this._$timeout(()=>{
this._showCompletionText=!1;
this._outstandingTextUpdate=null;
},timeInSeconds*1000);
});
}

get currentStatusText(){

return this.showInProgressText?this.inProgressText:this.completionText;
}

get showInProgressText(){
return this.command.inProgress||this.command.completed&&this.completionText.length===0;
}

get showCompletionText(){
return this._showCompletionText;
}};



module.exports=CommandStatusDirective;
//# sourceMappingURL=commandStatusDirective.js.map
